// extracted by mini-css-extract-plugin
var _1 = "Divider-moduleDivider__Sx6Rx";
export { _1 as "Divider" }
